// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-container[data-v-7175aa86]{min-height:100vh;min-height:-webkit-fill-available;padding-bottom:5rem!important}.request[data-v-7175aa86]{min-height:100vh;margin-top:8rem;grid-gap:1rem;gap:1rem}.request__btn[data-v-7175aa86] .v-btn__content{line-height:1.55}.request__form[data-v-7175aa86]{height:100%;grid-gap:1rem;gap:1rem}.request__message[data-v-7175aa86]{font-size:.75rem;line-height:1;letter-spacing:.1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
